module.exports = __webpack_public_path__ + "static/fonts/AndaleMono.407def7.ttf";